export interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

function isEnabled(domain: string): boolean {
  if (import.meta.env.DEV) return true;
  try {
    const setting = localStorage.getItem('debug') ?? '';
    return setting === '*' || setting.split(',').map(s => s.trim()).includes(domain);
  } catch {
    return false;
  }
}

export function createLogger(domain: string): Logger {
  const prefix = `[${domain}]`;
  return {
    debug: (...args) => { if (isEnabled(domain)) console.debug(prefix, ...args); },
    info: (...args) => { if (isEnabled(domain)) console.log(prefix, ...args); },
    warn: (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
  };
}
